export const SYMBOLS_FETCH = 'SYMBOLS_FETCH';
export const BASE_SYMBOLS_FETCH = 'BASE_SYMBOLS_FETCH';
export const SYMBOLS_IS_FETCING = 'SYMBOLS_IS_FETCING';
export const SYMBOLS_API = 'symbols';
export const SYMBOL_EDIT = 'SYMBOL_EDIT';
export const SYMBOL_SAVE = 'SYMBOL_SAVE';
export const SYMBOL_FILTER = 'SYMBOL_FILTER';


// WEBPACK FOOTER //
// ./src/constants/symbols.js